import { IRecipientSearchLog } from "./recipient-search-log";

export interface IRecipientList{
    recpId: number,
    recpCreatedOn: string,
    recpDateUpdated: string
    recpDateBirth: string,
    recpIsDeleted: boolean,
    recpAlias: string,
    recpGender: string,
    recpBloodType: string,
    recpStatus: number,
    recpStatusDesc: string,
    ctrId: number,
    ctrAlias: string,
    isExportable: boolean,
    age: number,
    logs: IRecipientSearchLog[]
}